export default __webpack_public_path__ + "images/36937d34045b9ff7f83c7bf78c38cdda-raffle.webp";